<section class="container-fluid py-4">
  <div class="row justify-content-md-center mx-0">
    <div class="col-md-7 border-form p-md-5 p-4">
      <h1 class="mb-3" data-test-id="bind-authenticator-title">
        {{ 'BIND_AUTHENTICATOR_TITLE_HINT' | translate }}
      </h1>
      <div data-test-id="wrap-bind-authenticator">
        <ol>
          <li>
            {{ 'BIND_AUTHENTICATOR_DESCRIPTION_PART1' | translate }}<br />
            <span class="text-muted">{{ 'BIND_AUTHENTICATOR_HINT_PART1' | translate }}</span>
          </li>
          <li>{{ 'BIND_AUTHENTICATOR_DESCRIPTION_PART2' | translate }}</li>
          <li>
            {{ 'BIND_AUTHENTICATOR_DESCRIPTION_PART3' | translate }}<br />
            <div *ngIf="authenticatorSecret" class="d-flex flex-column align-items-center justify-content-center m-3">
              <app-qr-code [qrCodeUrl]="authenticatorSecret"></app-qr-code>
              <div>{{ authenticatorSecretPart }}</div>
            </div>
            <span class="text-muted">{{ 'BIND_AUTHENTICATOR_HINT_PART3' | translate }}</span>
          </li>
          <li>
            {{ 'BIND_AUTHENTICATOR_DESCRIPTION_PART4' | translate }}<br />
            <span class="text-muted">{{ 'BIND_AUTHENTICATOR_HINT_PART4' | translate }}</span>
          </li>
        </ol>
      </div>
      <button
        class="btn btn-primary me-3"
        type="button"
        data-test-id="bind-authenticator-return-btn"
        (click)="returnToPreviousPage()"
      >
        {{ 'BIND_AUTHENTICATOR_RETURN_BTN' | translate }}
      </button>
    </div>
  </div>
</section>
